module.exports = __webpack_public_path__ + "img/Bitmex Futures.12c0a713.png";